export default "__VITE_ASSET__C4I3VRjY__"